import React from "react";
import {axiosCommon} from "../../../util/axiosSetup.js";
import {BASE_URL} from "../../../util/Urls";
import getGeneralError from "../../../util/getGeneralError";
import Footer from "../../../components/Footer";
import Search from "../../../components/Search";
import Card from "../../../components/Card";
import Widget from "../../../components/Widget";
import {
    Paper,
    TextField, Typography, Button, Toolbar, Tab
} from "@material-ui/core";
import RowsPerPageOptions from "../../../util/RowsPerPageOptions";
import NavHeader from "../../../components/NavHeader";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { DataGrid, GridToolbarContainer, GridToolbarExport } from "@material-ui/data-grid";
import NoData from "../../../components/NoData";
import HighlightCard from "../../../components/HighlightCard";
import TabPanel from "../../../components/TabPanel";
import TabList from "../../../components/TabList";

export default class DeliveryProductMatchListPage extends React.Component {
    constructor() {
        super();
        this.state = {
            lastDownloadTimestamp: null,
            tabIndex: 0,
            keyword: "",
            shopOptions: [],
            selectedShopOption: null,
            error: null,
            isLoading: false,
            deliveryProductRows: [],
            deliveryProducts: [],
            deliveryProductDuplicateIds: {},
            deliveryProductRowsPerPage: RowsPerPageOptions.defaultPageSize,
            deliveryProductColumns: [
                {field: 'bythepayId', headerName: 'ID', align: 'left', headerAlign: 'left', width: 70},
                {field: 'deliveryName', headerName: 'Wolt Termék', align: 'left', headerAlign: 'left', minWidth: 200, flex: 1, renderCell: this.renderLineBreakCell},
                {field: 'deliveryPrice', headerName: 'Wolt Ár (%)', align: 'center', headerAlign: 'center', minWidth: 140,},
                {field: 'deliveryVat', headerName: 'Wolt Áfa (%)', align: 'center', headerAlign: 'center', minWidth: 140,},
                {field: 'name', headerName: 'Bythepay Termék', align: 'left', headerAlign: 'left', minWidth: 200, flex: 1, renderCell: this.renderLineBreakCell},
                {field: 'price', headerName: 'Eladási Ár (Ft)', align: 'center', headerAlign: 'center', minWidth: 150,},
                {field: 'vat', headerName: 'Elviteli Áfa (%)', align: 'center', headerAlign: 'center', minWidth: 150,},],

            deliveryOptions: [],
            deliveryOptionRows: [],
            deliveryOptionRowsPerPage: RowsPerPageOptions.defaultPageSize,
            deliveryOptionColumns: [
                {field: 'bythepayId', headerName: 'ID', align: 'left', headerAlign: 'left', width: 70},
                {field: 'deliveryName', headerName: 'Wolt Opció', align: 'left', headerAlign: 'left', minWidth: 200, renderCell: this.renderLineBreakCell},
                {field: 'name', headerName: 'Bythepay Feltét csoport', align: 'left', headerAlign: 'left', minWidth: 250, renderCell: this.renderLineBreakCell},],

            deliveryOptionProducts: [],
            deliveryOptionProductRows: [],
            deliveryOptionProductRowsPerPage: RowsPerPageOptions.defaultPageSize,
            deliveryOptionProductColumns: [
                {field: 'bythepayId', headerName: 'ID', align: 'left', headerAlign: 'left', width: 70},
                {field: 'deliveryOptionName', headerName: 'Wolt Opció', align: 'left', headerAlign: 'left', minWidth: 200, flex: 1, renderCell: this.renderLineBreakCell},
                {field: 'deliveryName', headerName: 'Wolt opció Termék', align: 'left', headerAlign: 'left', minWidth: 200, flex: 1, renderCell: this.renderLineBreakCell},
                {field: 'deliveryPrice', headerName: 'Wolt Ár (%)', align: 'center', headerAlign: 'center', minWidth: 140,},
                {field: 'deliveryVat', headerName: 'Wolt Áfa (%)', align: 'center', headerAlign: 'center', minWidth: 140,},
                {field: 'optionName', headerName: 'Bythepay Feltét csoport', align: 'left', headerAlign: 'left', minWidth: 200, flex: 1, renderCell: this.renderLineBreakCell},
                {field: 'name', headerName: 'Bythepay Termék', align: 'left', headerAlign: 'left', minWidth: 200, flex: 1, renderCell: this.renderLineBreakCell},
                {field: 'price', headerName: 'Eladási Ár (Ft)', align: 'center', headerAlign: 'center', minWidth: 150,},
                {field: 'vat', headerName: 'Elviteli Áfa (%)', align: 'center', headerAlign: 'center', minWidth: 150,},],
        };
        this.searchTimeout = 0
    }

    renderLineBreakCell = (params) => {
        return <div style={{ whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: 1.4 }}>
            {params.value}
        </div>
    }

    componentDidMount() {
        axiosCommon.get(`${BASE_URL}/api/shops`)
        .then(response => {
            const shopOptions = response.data.items;
            const selectedShopOption = shopOptions.length > 0 ? shopOptions[0] : null;
            this.setState({
                shopOptions,
                selectedShopOption,
            }, () => this.refreshData());
        });
    }

    onChangeShopFilter = (event, value) => {
        this.setState({ selectedShopOption: value, deliveryProductRows: [], lastDownloadTimestamp: null});
    };

    downloadProducts = () => {
        this.setState({
            isLoading: true,
            error: null,
            keyword: "",
            deliveryProductRows: [],});

        const queryParams = {
            deliverySource: 'WOLT',
            shopId: this.state.selectedShopOption.id
        }

        axiosCommon(`${BASE_URL}/api/products/delivery-matches?`,{ params: queryParams })
        .then(response => {
            const { deliveryProducts, deliveryOptions, deliveryOptionProducts } = response.data;


            const duplicateIds = {};
            deliveryProducts.forEach(product => {
                if (product.id != null) {
                    duplicateIds[product.id] = (duplicateIds[product.id] || 0) + 1;
                }
            })

            const deliveryProductDuplicateIds = Object.fromEntries(
                Object.entries(duplicateIds).filter(([_, count]) => count > 1)
            );

            const deliveryProductRows = deliveryProducts.map((e, i) => {
                return {
                    id: i,
                    bythepayId: e.id,
                    name: e.name,
                    price: e.sellingPrice,
                    vat: e.vat,
                    deliveryName: e.deliveryName,
                    deliveryPrice: e.deliverySellingPrice,
                    deliveryVat: e.deliveryVat,
                }
            })

            const deliveryOptionRows = deliveryOptions.map((e, i) => {
                return {
                    id: i,
                    bythepayId: e.id,
                    name: e.name,
                    deliveryName: e.deliveryName,
                }
            })

            const deliveryOptionProductRows = deliveryOptionProducts.map((e, i) => {
                return {
                    id: i,
                    bythepayId: e.id,
                    deliveryOptionName: e.deliveryOptionName,
                    deliveryName: e.deliveryName,
                    deliveryPrice: e.deliverySellingPrice,
                    deliveryVat: e.deliveryVat,
                    optionName: e.optionName,
                    name: e.name,
                    price: e.sellingPrice,
                    vat: e.vat,
                }
            })

            this.setState({
                deliveryProducts,
                deliveryProductDuplicateIds,
                deliveryProductRows,
                deliveryOptions,
                deliveryOptionRows,
                deliveryOptionProducts,
                deliveryOptionProductRows,
                keyword: ""})
        })
        .catch(error => { this.setState({ error })})
        .finally(() => { this.setState({isLoading: false, })})
    };

    refreshData = () => {
        let filteredDeliveryProduct = this.state.deliveryProducts
        let filteredDeliveryOptions = this.state.deliveryOptions
        let filteredDeliveryOptionProducts = this.state.deliveryOptionProducts

        if (this.state.keyword?.length > 0){
            const keyword = this.state.keyword.toLowerCase()

            filteredDeliveryProduct = filteredDeliveryProduct.filter(product =>
                product.name?.toLowerCase().includes(keyword) ||
                product.deliveryName?.toLowerCase().includes(keyword) ||
                product.id?.toString().includes(keyword)
            )

            filteredDeliveryOptions = filteredDeliveryOptions.filter(option =>
                option.name?.toLowerCase().includes(keyword) ||
                option.deliveryName?.toLowerCase().includes(keyword) ||
                option.id?.toString().includes(keyword)
            )

            filteredDeliveryOptionProducts = filteredDeliveryOptionProducts.filter(optionProduct =>
                optionProduct.name?.toLowerCase().includes(keyword) ||
                optionProduct.deliveryName?.toLowerCase().includes(keyword) ||
                optionProduct.deliveryOptionName?.toLowerCase().includes(keyword) ||
                optionProduct.id?.toString().includes(keyword) ||
                optionProduct.optionName?.toLowerCase().includes(keyword)
            )
        }

        const deliveryProductRows = filteredDeliveryProduct.map((e, i) => {
            return {
                id: i,
                bythepayId: e.id,
                name: e.name,
                price: e.sellingPrice,
                vat: e.vat,
                deliveryName: e.deliveryName,
                deliveryPrice: e.deliverySellingPrice,
                deliveryVat: e.deliveryVat,
            }
        })

        const deliveryOptionRows = filteredDeliveryOptions.map((e, i) => {
            return {
                id: i,
                bythepayId: e.id,
                name: e.name,
                deliveryName: e.deliveryName,
            }
        })

        const deliveryOptionProductRows = filteredDeliveryOptionProducts.map((e, i) => {
            return {
                id: i,
                bythepayId: e.id,
                deliveryOptionName: e.deliveryOptionName,
                deliveryName: e.deliveryName,
                deliveryPrice: e.deliverySellingPrice,
                deliveryVat: e.deliveryVat,
                optionName: e.optionName,
                name: e.name,
                price: e.sellingPrice,
                vat: e.vat,
            }
        })

        this.setState({deliveryProductRows, deliveryOptionRows, deliveryOptionProductRows})
    };

    setKeyword = (event) => {
        this.setState({ keyword: event.target.value })
        if(this.searchTimeout) clearTimeout(this.searchTimeout)

        this.searchTimeout = setTimeout(() => {
            this.refreshData()
        },350)
    }

    renderHighligthCards = () => {
        switch (this.state.tabIndex) {
            case 0: {
                return <>
                    <section className="flex justify-flex-end mb-16 gap-8" >
                        <HighlightCard
                            title={this.renderColorBox("Wolt termék pár nélkül (db)","rgba(255,199,6, 0.4)")}
                            tooltip="Azon Wolt termékek száma, amelyekhez nincs Bythepay termék párosítva.">
                            <Typography variant="h3" align="center">
                                {this.state.deliveryProducts.filter(product => product.name === null).length.toLocaleString('hu-HU', {})}
                            </Typography>
                        </HighlightCard>
                        <HighlightCard
                            title={this.renderColorBox("Wolt termék azonos ID-val (db)","rgba(255,42,0,0.4)")}
                            tooltip="Azon Wolt termékek száma, amelyekhez azonos Bythepay ID tartozik.">
                            <Typography variant="h3" align="center">
                                {Object.values(this.state.deliveryProductDuplicateIds).reduce((sum, count) => sum + count, 0).toLocaleString('hu-HU', {})}
                            </Typography>
                        </HighlightCard>
                    </section>
                </>
            }
            case 1: {
                return <>
                    <section className="flex justify-flex-end mb-16 gap-8" >
                        <HighlightCard
                            title={this.renderColorBox("Wolt opciók pár nélkül (db)","rgba(255,199,6, 0.4)")}
                            tooltip="Azon Wolt opciók száma, amelyekhez nincs Bythepay feltét csoport párosítva.">
                            <Typography variant="h3" align="center">
                                {this.state.deliveryOptions.filter(option => option.name === null).length.toLocaleString('hu-HU', {})}
                            </Typography>
                        </HighlightCard>
                    </section>
                </>
            }
            case 2: {
                return <>
                    <section className="flex justify-flex-end mb-16 gap-8" >
                        <HighlightCard
                            title={this.renderColorBox("Wolt opciók termék pár nélkül (db)","rgba(255,199,6, 0.4)")}
                            tooltip="Azon Wolt opció termékek száma, amelyekhez nincs Bythepay feltét termék párosítva.">
                            <Typography variant="h3" align="center">
                                {this.state.deliveryOptionProducts.filter(option => option.name === null).length.toLocaleString('hu-HU', {})}
                            </Typography>
                        </HighlightCard>
                    </section>
                </>
            }
            default: return undefined
        }
    }

    renderColorBox = (text, color) => {
        return <div style={{display: "flex"}}>
            <div style={{width: 25, height: 25, background: color, borderRadius: 3, marginRight: 10}}/>
            {text}
        </div>
    }

    renderList = () => {
        return <>
            <TabList
                value={this.state.tabIndex}
                onChange={(event, newValue) => {
                    this.setState({tabIndex: newValue});
                }}
            >
                <Tab label="Termékek"/>
                <Tab label="Opciók"/>
                <Tab label="Opció termékek"/>
            </TabList>

            <Widget>
                <Card title="Szűrés üzlet alapján">
                    <Autocomplete
                        fullWidth
                        noOptionsText="Nincs ilyen tétel"
                        options={this.state.shopOptions}
                        onChange={this.onChangeShopFilter}
                        disableClearable
                        getOptionLabel={(option) => option === "" ? "" : option.name}
                        getOptionSelected={(option, value) => option.id === value.id}
                        value={this.state.selectedShopOption || ""}
                        renderInput={(params) =>
                            <TextField {...params} label="Üzlet" variant="outlined" />
                        }
                    />
                </Card>
                <div className="m-8"/>
                <Card title="Keresés a névben / ID-ban">
                    <Search
                        setKeyword={this.setKeyword}
                        refreshData={this.refreshData}
                        value={this.state.keyword}
                    />
                </Card>
            </Widget>

            <Widget>
                <Card title="Termékek letöltése a Wolt-ról">
                    <Typography variant="body1">
                        A termékek letöltése a Wolt-ról csak korlátozott időközönként lehetséges, így a letöltés után 15 percig a funkció nem lesz elérhető.
                    </Typography>
                    <br/>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        style={{ color: 'white' }}
                        onClick={() => {
                            this.setState({ lastDownloadTimestamp: Date.now() }, () => {
                                this.downloadProducts();
                                setTimeout(() => {this.setState({ lastDownloadTimestamp: null, error: null });}, 60 * 1000);
                            });
                        }}
                        disabled={this.state.lastDownloadTimestamp != null}
                    >
                        Letöltés
                    </Button>

                </Card>
                <div className="m-8"/>
                <div className="flex-1">
                    {this.renderHighligthCards()}
                </div>
            </Widget>

            <TabPanel value={this.state.tabIndex} index={0}>
                {this.state.error
                    ? <Typography variant="body1" style={{fontSize: 18, fontWeight: 800, color: 'red'}}>{getGeneralError(this.state.error)}</Typography>
                    :<>
                        <>
                            <Toolbar style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                <div style={{display: 'flex', flexDirection: 'row'}}>
                                    <Typography variant="h5" id="tableTitle" component="div">
                                        Wolt termékek
                                    </Typography>
                                </div>
                            </Toolbar>
                            <Paper className="mb-16">
                                <DataGrid
                                    columns={this.state.deliveryProductColumns}
                                    rows={this.state.deliveryProductRows}
                                    className="cursor-pointer"
                                    disableSelectionOnClick
                                    disableColumnMenu
                                    autoHeight
                                    onPageSizeChange={(entry) => this.setState({ deliveryProductRowsPerPage: parseInt(entry, 10) })}
                                    rowsPerPageOptions={RowsPerPageOptions.items}
                                    pageSize={this.state.deliveryProductRowsPerPage}
                                    pagination
                                    loading={this.state.isLoading}
                                    components={{
                                        Toolbar: () => {
                                            return (
                                                <GridToolbarContainer>
                                                    <GridToolbarExport/>
                                                </GridToolbarContainer>
                                            );
                                        },
                                        NoRowsOverlay: NoData,
                                    }}
                                    getRowClassName={(params) => {
                                        if (params.row.id != null && this.state.deliveryProductDuplicateIds[params.row.bythepayId]) return 'inventory-row-red';
                                        if (params.row.name === null) return 'inventory-row-yellow';
                                        return '';
                                    }}
                                />
                            </Paper>
                        </>
                    </>
                }
            </TabPanel>

            <TabPanel value={this.state.tabIndex} index={1}>
                {this.state.error
                    ? <Typography variant="body1" style={{fontSize: 18, fontWeight: 800, color: 'red'}}>{getGeneralError(this.state.error)}</Typography>
                    :<>
                        <>
                            <Toolbar style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                <div style={{display: 'flex', flexDirection: 'row'}}>
                                    <Typography variant="h5" id="tableTitle" component="div">
                                        Wolt opciók
                                    </Typography>
                                </div>
                            </Toolbar>
                            <Paper className="mb-16">
                                <DataGrid
                                    columns={this.state.deliveryOptionColumns}
                                    rows={this.state.deliveryOptionRows}
                                    className="cursor-pointer"
                                    disableSelectionOnClick
                                    disableColumnMenu
                                    autoHeight
                                    onPageSizeChange={(entry) => this.setState({ deliveryOptionRowsPerPage: parseInt(entry, 10) })}
                                    rowsPerPageOptions={RowsPerPageOptions.items}
                                    pageSize={this.state.deliveryOptionRowsPerPage}
                                    pagination
                                    loading={this.state.isLoading}
                                    components={{
                                        Toolbar: () => {
                                            return (
                                                <GridToolbarContainer>
                                                    <GridToolbarExport/>
                                                </GridToolbarContainer>
                                            );
                                        },
                                        NoRowsOverlay: NoData,
                                    }}
                                    getRowClassName={(params) => {
                                        if (params.row.name === null) return 'inventory-row-yellow';
                                        return '';
                                    }}
                                />
                            </Paper>
                        </>
                    </>
                }
            </TabPanel>

            <TabPanel value={this.state.tabIndex} index={2}>
                {this.state.error
                    ? <Typography variant="body1" style={{fontSize: 18, fontWeight: 800, color: 'red'}}>{getGeneralError(this.state.error)}</Typography>
                    :<>
                        <>
                            <Toolbar style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                <div style={{display: 'flex', flexDirection: 'row'}}>
                                    <Typography variant="h5" id="tableTitle" component="div">
                                        Wolt opciók
                                    </Typography>
                                </div>
                            </Toolbar>
                            <Paper className="mb-16">
                                <DataGrid
                                    columns={this.state.deliveryOptionProductColumns}
                                    rows={this.state.deliveryOptionProductRows}
                                    className="cursor-pointer"
                                    disableSelectionOnClick
                                    disableColumnMenu
                                    autoHeight
                                    onPageSizeChange={(entry) => this.setState({ deliveryOptionProductRowsPerPage: parseInt(entry, 10) })}
                                    rowsPerPageOptions={RowsPerPageOptions.items}
                                    pageSize={this.state.deliveryOptionProductRowsPerPage}
                                    pagination
                                    loading={this.state.isLoading}
                                    components={{
                                        Toolbar: () => {
                                            return (
                                                <GridToolbarContainer>
                                                    <GridToolbarExport/>
                                                </GridToolbarContainer>
                                            );
                                        },
                                        NoRowsOverlay: NoData,
                                    }}
                                    getRowClassName={(params) => {
                                        if (params.row.name === null) return 'inventory-row-yellow';
                                        return '';
                                    }}
                                />
                            </Paper>
                        </>
                    </>
                }
            </TabPanel>

        </>
    }

    render() {
        return <>
            <section className="main-content">
                <section className="main-content-body">
                    <NavHeader changeSidebarToggled={this.props.changeSidebarToggled}/>
                    {this.renderList()}
                </section>
                <Footer/>
            </section>
        </>;
    }
}
